<template>
  <div style="min-height: 600px;">
    <navbar></navbar>
    <info></info>
    <gallery id="Dashboard" :isTop="!boolTop"></gallery>
    <!--<services></services>-->
    <projects></projects>
    <contact></contact>
    <footerBox></footerBox>
   </div>
</template>
<script>
  import navbar from '../components/Home/navbar'
  import info from '../components/Home/info'
  import gallery from '../components/Home/gallery'
  import slides from '../components/Home/slides'
  import services from '../components/Home/services'
  import divider from '../components/Home/divider'
  // import price from '../components/Home/price'
  import projects from '../components/Home/projects'
  import contact from '../components/Home/contact'
  import footerBox from '../components/Home/footer'
  // import chromecastImages from '../lib/chromecast.json'
  export default {
    name: 'home',
    components: { navbar, info, slides, gallery, services, divider, projects, contact, footerBox },
    data () {
      return {
        activeMenu: 'HOME',
        boolTop: true,
        msg: '',
        randomImages: []
      }
    },
    created () {
      // this.initRandomImage(20)
      console.log('created: this.$root.isLoggedIn = ' + this.$root.isLoggedIn)
      if (this.$root.isLoggedIn) {
        this.$root.goto('Dashboard')
      }
    },
    mounted () {
    },
    updated () {
    },
    computed: {
    },
    methods: {
      landingClick () {
        console.log('landingClick () ....')
      },
      initRandomImage (max) {
        let vm = this
        if (vm.randomImages.length < max) {
          let image = chromecastImages[Math.floor(Math.random() * chromecastImages.length)]
          console.log(image)
          vm.checkImageURL(image.url).then((res) => {
            console.log(res)
            // vm.randomImages.push(image)
            vm.randomImages.push({ src: image.url, caption: image.author })
            vm.initRandomImage(max)
          }).catch((err) => {
            console.log(err)
            vm.initRandomImage(max)
          })
        }
      },
      checkImageURL (url) {
        return new Promise(function (resolve, reject) {
          // let timeout = 15000
          // let timer
          let img = new Image()
          img.src = url
          img.onerror = img.onabort = function () {
            // clearTimeout(timer)
            reject('error')
          }
          img.onload = function () {
            // clearTimeout(timer)
            resolve('success')
          }
        })
      }
    }
  }
</script>
<style>
  .spacer{
    width: 100%;
    height: 120px;
  }
  div.vue-friendly-iframe {
    width: 100%;
    height: 100%;
  }
    div.vue-friendly-iframe > iframe {
      width: 100%;
      height: 100%;
    }
</style>



// WEBPACK FOOTER //
// Home.vue?b8b6025c